import { useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { BACKEND_URL } from '../constants';

// Fige sur le devis DOMIUM les réglages du super admin (déjà adhérent, échéancier)
export default function useDomiumParametres({ isSuperAdmin, savedSimulation, setSavedSimulation, isFtpeMember, headers }) {
  const ref = savedSimulation?.reference;
  const dernierFtpe = useRef(null);

  const enregistrer = useCallback((body) => {
    if (!isSuperAdmin || !ref) return;
    axios.post(`${BACKEND_URL}/api/domium/subscribe/${encodeURIComponent(ref)}/parametres-devis`, body, { headers })
      .then((r) => setSavedSimulation((s) => (s ? { ...s, parametres_devis: r.data.parametres_devis } : s)))
      .catch(() => toast.error("Réglage du devis DOMIUM non enregistré"));
  }, [isSuperAdmin, ref, headers, setSavedSimulation]);

  useEffect(() => {
    const cle = `${ref}:${!!isFtpeMember}`;
    if (!isSuperAdmin || !ref || dernierFtpe.current === cle) return;
    dernierFtpe.current = cle;
    enregistrer({ deja_adherent: !!isFtpeMember });
  }, [isSuperAdmin, ref, isFtpeMember, enregistrer]);

  const enregistrerRef = useRef(enregistrer);
  enregistrerRef.current = enregistrer;
  const dernierPlan = useRef(null);
  const onPlanChange = useCallback((plan) => {
    if (!plan?.is_custom) return;
    const override = {
      acompte_pct: plan.acompte_pct, nb_echeances: plan.nb_echeances, offsets_days: plan.offsets_days,
      acompte_date: plan.acompte_date, dates_iso: plan.dates_iso, montants_eur: plan.montants_eur, force_eligible: true,
    };
    const cle = JSON.stringify(override);
    if (dernierPlan.current === cle) return;
    dernierPlan.current = cle;
    enregistrerRef.current({ echelonnement_override: override });
  }, []);

  return { onPlanChange };
}
